import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function About() {
    const [content, setContent] = useState("");
    useEffect(() => { api.get("/policies/about").then(({ data }) => setContent(data.policy.content)).catch(() => {}); }, []);

    return (
        <div>
            <section className="relative h-[45vh] min-h-[320px] overflow-hidden">
                <img src="https://images.unsplash.com/photo-1615292026763-3af006e59a67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxiZWF1dGlmdWwlMjBpbmRpYW4lMjB3b21hbiUyMGhhaXJ8ZW58MHx8fHwxNzg2NzI4NDQ0fDA&ixlib=rb-4.1.0&q=85" alt="ELVOSH" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/35 flex items-center justify-center">
                    <div className="text-center text-white">
                        <p className="eyebrow text-gold mb-3">Our Story</p>
                        <h1 className="font-serif text-4xl md:text-6xl tracking-tight">About ELVOSH</h1>
                    </div>
                </div>
            </section>
            <div className="mx-auto max-w-3xl px-5 py-16 md:py-24">
                <div className="prose-elvosh whitespace-pre-line text-lg text-muted-foreground leading-relaxed text-center">
                    {content}
                </div>
                <div className="text-center mt-12">
                    <Link to="/shop" className="inline-block bg-gold text-white px-10 py-4 text-sm uppercase tracking-[0.18em] hover:bg-gold-hover transition-colors">Explore the Collection</Link>
                </div>
            </div>
        </div>
    );
}
